module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/flask-fill-8dc3a0a42137dcab0cfb7a6c360ab45c.svg";